export default "__VITE_ASSET___ygAxo1SXThqFbkT129hvw__"